module.exports = __webpack_public_path__ + "static/media/RUS.bfeeda19.svg";